(function() {
  // ── CONFIG ─
 
 // Live script url
 var APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbyeJ7RzR7c8gqFmQqNrUSmwrsjnL33dAHzp2mPg_Xy_AFnhXJKzRDw3owfAcZ7kcdo/exec";
  

 var SECRET_TOKEN    = "canvasloft2026ugc";
  var MAX_FILE_SIZE   = 10 * 1024 * 1024 * 1024;
  var CHUNK_SIZE      = 5 * 1024 * 1024;
  var MAX_FILES       = 30;
  var MAX_CHUNK_RETRIES = 3;
  var ACCEPTED_EXT    = [
    ".jpg",".jpeg",".png",".heic",".heif",".webp",
    ".gif",".tiff",".tif",".bmp",".dng",
    ".cr2",".cr3",".nef",".arw",".raf",".orf",".rw2",".pef",
    ".mp4",".mov",".m4v",".avi",".mkv",".webm",
    ".mpeg",".mpg",".wmv",".3gp",".mts",".m2ts"
  ];
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // ────────────────────────────────────────────────────────────

  var selectedFiles = [];

  var dropzone  = document.getElementById("ugc-dropzone");
  var fileInput = document.getElementById("ugc-fileInput");
  var fileList  = document.getElementById("ugc-fileList");
  var form      = document.getElementById("ugc-review-form");
  var submitBtn = document.getElementById("ugc-submitBtn");
  var submitLbl = document.getElementById("ugc-submitLabel");
  var progWrap  = document.getElementById("ugc-prog-wrap");
  var progFill  = document.getElementById("ugc-prog-fill");
  var progLabel = document.getElementById("ugc-prog-label");
  var errBanner = document.getElementById("ugc-err-banner");
  var successEl = document.getElementById("ugc-success");

  // ── Drag & drop ──────────────────────────────────────────────
  dropzone.addEventListener("dragover", function(e) { e.preventDefault(); dropzone.classList.add("is-dragover"); });
  dropzone.addEventListener("dragleave", function() { dropzone.classList.remove("is-dragover"); });
  dropzone.addEventListener("drop", function(e) {
    e.preventDefault(); dropzone.classList.remove("is-dragover");
    addFiles(Array.from(e.dataTransfer.files));
  });
  fileInput.addEventListener("change", function() { addFiles(Array.from(fileInput.files)); fileInput.value = ""; });

  // ── Consent error clear on tick ─────────────────────────────
  var consentCheck = document.getElementById("ugc-consent");
  if (consentCheck) {
    consentCheck.addEventListener("change", function() {
      var errConsent = document.getElementById("err-consent");
      if (errConsent && consentCheck.checked) errConsent.textContent = "";
    });
  }

  // ── Floating label ───────────────────────────────────────────
  ["ugc-fullName", "ugc-email"].forEach(function(id) {
    var inp = document.getElementById(id);
    inp.addEventListener("input", function() {
      inp.closest(".field").classList.toggle("has-value", inp.value.trim() !== "");
    });
  });

  // ── File handling ────────────────────────────────────────────
  function addFiles(newFiles) {
    newFiles.forEach(function(f) {
      if (selectedFiles.length >= MAX_FILES) {
        showErr("You can upload up to " + MAX_FILES + " files per submission.");
        return;
      }
      var ext = f.name.lastIndexOf(".") > -1 ? f.name.slice(f.name.lastIndexOf(".")).toLowerCase() : "";
      if (f.size > MAX_FILE_SIZE) { showErr(f.name + " is too large (max 10 GB)."); return; }
      if (!f.type.startsWith("image/") && !f.type.startsWith("video/") && ACCEPTED_EXT.indexOf(ext) === -1) {
        showErr(f.name + " — file type not supported."); return;
      }
      var dup = selectedFiles.some(function(x) { return x.name === f.name && x.size === f.size; });
      if (!dup) selectedFiles.push(f);
    });
    renderFileList();
  }

  function removeFile(idx) { selectedFiles.splice(idx, 1); renderFileList(); }

   function renderFileList() {
    fileList.innerHTML = "";
    selectedFiles.forEach(function(f, i) {
      var isVideo = f.type && f.type.startsWith("video/");

      var li = document.createElement("li");

      var icon = document.createElement("span");
      icon.className = "fi-icon";
      icon.textContent = isVideo ? "🎬" : "🖼️";

      var nameEl = document.createElement("span");
      nameEl.className = "file-name";
      nameEl.textContent = f.name;

      var sizeEl = document.createElement("span");
      sizeEl.className = "file-size";
      sizeEl.textContent = fmtSize(f.size);

      var removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "file-remove";
      removeBtn.setAttribute("aria-label", "Remove");
      removeBtn.textContent = "✕";
      removeBtn.addEventListener("click", function() { removeFile(i); });

      li.appendChild(icon);
      li.appendChild(nameEl);
      li.appendChild(sizeEl);
      li.appendChild(removeBtn);
      fileList.appendChild(li);
    });
  }

  function fmtSize(b) {
    if (b < 1024) return b + " B";
    if (b < 1048576) return (b / 1024).toFixed(1) + " KB";
    if (b < 1073741824) return (b / 1048576).toFixed(1) + " MB";
    return (b / 1073741824).toFixed(2) + " GB";
  }

  function showErr(msg) {
    errBanner.textContent = msg;
    errBanner.classList.add("show");
    setTimeout(function() { errBanner.classList.remove("show"); }, 6000);
  }

  function isValidEmail(email) {
    return EMAIL_REGEX.test(email);
  }

  // ── POST helper — token auto attach ──
  function appsPost(body) {
    body.token = SECRET_TOKEN;
    return fetch(APPS_SCRIPT_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); });
  }

  function delay(ms) { return new Promise(function(r) { setTimeout(r, ms); }); }

  // ── Success show ─────────────────────────────────────────────
  function showSuccess(name, email) {
    form.style.cssText = "display:none !important;";
    progWrap.style.cssText = "display:none !important;";
    successEl.removeAttribute("hidden");
    successEl.setAttribute("style", "display:flex !important;");
    document.getElementById("ugc-successName").textContent  = name.split(" ")[0] || name;
    document.getElementById("ugc-successEmail").textContent = email;

    setTimeout(function() {
    successEl.scrollIntoView({ behavior: "smooth", block: "center" });
  }, 100);
  }

  // ── Form submit ──────────────────────────────────────────────
  form.addEventListener("submit", function(e) {
    e.preventDefault();

    var name    = document.getElementById("ugc-fullName").value.trim();
    var email   = document.getElementById("ugc-email").value.trim();
    var consent = document.getElementById("ugc-consent").checked;

    // Clear errors
    document.getElementById("err-fullName").textContent = "";
    document.getElementById("err-email").textContent    = "";
    document.getElementById("err-files").textContent    = "";
    errBanner.classList.remove("show");

    // Validate
    var valid = true;
    if (!name)  { document.getElementById("err-fullName").textContent = "Please enter your full name."; valid = false; }
    if (!isValidEmail(email)) { document.getElementById("err-email").textContent = "Please enter a valid email."; valid = false; }
    if (selectedFiles.length === 0) { document.getElementById("err-files").textContent = "Please add at least one photo or video."; valid = false; }
    if (!consent) {
      var errConsent = document.getElementById("err-consent");
      if (errConsent) errConsent.textContent = "Please agree to the sharing terms before submitting.";
      valid = false;
    }
    if (!valid) return;

    submitBtn.disabled = true;
    submitLbl.textContent = "Uploading…";
    progWrap.classList.add("show");

    var hasPhotos     = selectedFiles.some(function(f) { return !f.type.startsWith("video/"); });
var hasVideos     = selectedFiles.some(function(f) { return f.type.startsWith("video/"); });
var imageCount    = selectedFiles.filter(function(f) { return !f.type.startsWith("video/"); }).length;  // ← naya
var videoCount    = selectedFiles.filter(function(f) { return f.type.startsWith("video/"); }).length;   // ← naya
var totalBytes    = selectedFiles.reduce(function(s, f) { return s + f.size; }, 0);
    var uploadedSoFar = 0;

    uploadSequentially(0);

    function uploadSequentially(idx) {
      if (idx >= selectedFiles.length) {
        // All files done — notify Make.com
        progLabel.textContent = "Finishing up…";
       appsPost({
          action:        "notify",     
          customerName:  name,
          customerEmail: email,
          hasPhotos:     hasPhotos,
          hasVideos:     hasVideos,
          fileCount:     selectedFiles.length,
          imageCount:    imageCount,   
          videoCount:    videoCount    
        })
        .then(function()  { showSuccess(name, email); })
        .catch(function() { showSuccess(name, email); }); // files uploaded — show success even if notify fails
        return;
      }

      var file = selectedFiles[idx];
      progLabel.textContent = "Uploading " + file.name + " (" + (idx + 1) + "/" + selectedFiles.length + ")…";

      uploadChunked(file, name, email, function(done) {
        var pct = Math.min(99, Math.round(((uploadedSoFar + done) / totalBytes) * 100));
        progFill.style.width = pct + "%";
      })
      .then(function() {
        uploadedSoFar += file.size;
        uploadSequentially(idx + 1);
      })
      .catch(function(err) {
        showErr("Upload failed for " + file.name + ". Please try again.");
        submitBtn.disabled = false;
        submitLbl.textContent = "Submit and claim $25 credit";
        progWrap.classList.remove("show");
        progFill.style.width = "0%";
      });
    }
  });

  // ── Chunked upload ───────────────────────────────────────────
function uploadChunked(file, name, email, onProgress) {
  return new Promise(function(resolve, reject) {
    appsPost({
      action:        "start",
      customerName:  name,
      customerEmail: email,
      fileName:      file.name,
      mimeType:      file.type || "application/octet-stream",
      totalSize:     file.size
    })
    .then(function(d) {
      if (!d.success) { showErr(d.error); reject(d.error); return; }
      // ── sessionUri and folderId store ──
      nextChunk(file, d.sessionUri, d.folderId, 0, onProgress, resolve, reject, 0);
    })
    .catch(function() { reject("Network error starting upload"); });
  });
}

  // ── Now retries a failing chunk up to MAX_CHUNK_RETRIES times with
  // backoff before giving up, instead of failing the whole file on
  // one flaky network blip.
  function nextChunk(file, sessionUri, folderId, offset, onProgress, resolve, reject, attempt) {
  var end  = Math.min(offset + CHUNK_SIZE, file.size);
  var blob = file.slice(offset, end);
  var reader = new FileReader();

  reader.onload = function(e) {
    var b64 = e.target.result.split(",")[1];
    appsPost({
      action:      "chunk",
      sessionUri:  sessionUri,   
      folderId:    folderId,     // ← notify 
      chunkBase64: b64,
      start:       offset,
      end:         end - 1,
      totalSize:   file.size,
      mimeType:    file.type || "application/octet-stream"
    })
    .then(function(d) {
      if (!d.success) { retryOrFail(d.error || "Chunk upload failed"); return; }
      if (onProgress) onProgress(end);
      if (d.complete) { resolve(folderId); }  // ← folderId return
      else { nextChunk(file, sessionUri, folderId, end, onProgress, resolve, reject, 0); }
    })
    .catch(function() { retryOrFail("Network error on chunk"); });
  };
  reader.onerror = function() { retryOrFail("File read error"); };
  reader.readAsDataURL(blob);

  function retryOrFail(errMsg) {
    if (attempt < MAX_CHUNK_RETRIES) {
      delay(800 * Math.pow(2, attempt)).then(function() {
        nextChunk(file, sessionUri, folderId, offset, onProgress, resolve, reject, attempt + 1);
      });
    } else {
      reject(errMsg);
    }
  }
}

})();